/* eslint-disable no-unused-vars */
<template>
  <div class="topNav" :class="topNavActiveClass">
    <div class="navContent">
      <span
        class="logo"
        v-scroll-to="{ el: '#landing', offset: -75 }"
        @click="openMenu ? toggleNav() : null"
        >g.dev</span
      >
      <div class="m-btns">
        <img
          @click="setModalData({ modalType: 'settings' })"
          class="gear"
          alt="settings"
          :src="
            global.darkMode
              ? require('@/assets/images/icons/gear-blue.png')
              : require('@/assets/images/icons/gear-orange.png')
          "
        />
        <div
          class="mobileMenuBtn"
          @click="toggleNav()"
          :class="{ active: openMenu }"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="mainMenu" :class="{ active: openMenu }">
      <b-nav class="navMob">
        <b-nav-item
          v-for="(section, index) in primaryLinks"
          :key="index"
          :href="section.anchor"
          v-scroll-to="{ el: section.anchor, offset: -50 }"
          @click="toggleNav()"
          :class="{ active: openMenu }"
          >{{ section.title }}</b-nav-item
        >
      </b-nav>
    </div>
  </div>
</template>
    
<script>
import { mapState, mapActions } from "vuex";
import { navData } from "@/data/navData";
import { analyticsHelper } from "@/helpers";

export default {
  name: "MobileNav",

  data() {
    return {
      primaryLinks: navData(),
      topNavActiveClass: "",
      openMenu: false,
      analyticsHelper,
    };
  },
  mounted() {
    this.$root.$on("bv::scrollspy::activate", this.analyticsHelper.scrollTo);
  },
  methods: {
    toggleNav() {
      const newVal = !this.openMenu;
      this.openMenu = newVal;
      document.documentElement.style.overflow = !newVal ? "auto" : "hidden";
    },
    ...mapActions(["setModalData"]),
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>
    
<style lang="scss" scoped>
.topNav {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 5;
  width: 100%;
  background: #ffffff;
  transition: background-color 0.5s ease-in-out;
  padding-right: env(safe-area-inset-right);
  padding-left: env(safe-area-inset-left);
  height: 54px;
  // &.active{
  //   background-color: #000000;
  // }
}
.gear {
  height: 25px;
  width: 25px;
  margin-right: 24px;
}
.m-btns {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.logo {
  font-size: 25px;
  max-height: 80px;
  margin-right: 80px;
  font-family: $font-header;
  color: $lt-secondary-color;
}
.mainMenu {
  height: calc(100vh - 54px);
  position: fixed;
  top: 54px;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  transition: all 0.25s ease-in-out;
  visibility: hidden;
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 100;
  padding-bottom: 35px;
  background: #fff;
  .navMob {
    margin-top: 42px;
    width: 100%;
    flex: 1;
  }
  &.active {
    visibility: visible;
    opacity: 1;
  }
  li {
    list-style: none;
    padding: 8px 0;

    a {
      width: 100%;

      text-transform: uppercase;
      font-family: $font-primary;
      font-size: 16px;
      color: #000;
      letter-spacing: 0;
      text-align: center;
      line-height: 22px;
      transition: all 0.2s ease-in-out;
    }
  }
}

.navContent {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 54px;
  padding: 0 20px;
}

.nav-link {
  padding: 0 10px;
}

.nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mobileMenuBtn {
  height: 17px;
  width: 20px;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
  z-index: 4 !important;
  span {
    display: block;
    position: absolute;
    height: 3px;
    width: 100%;
    background: $lt-font-color;
    border-radius: 9px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    &:nth-child(1) {
      top: 0px;
    }
    &:nth-child(2) {
      top: 7px;
    }
    &:nth-child(3) {
      top: 14px;
    }
  }
  &.active {
    span {
      &:nth-child(1) {
        top: 7px;
        transform: rotate(135deg);
      }
      &:nth-child(2) {
        opacity: 0;
        left: -60px;
      }
      &:nth-child(3) {
        top: 7px;
        transform: rotate(-135deg);
      }
    }
  }
}
</style>


    
<style lang="scss" >
.dark {
  .topNav {
    background: $dt-bg-color;
  }
  .logo {
    color: $dt-secondary-color;
  }
  .mainMenu {
    background: $dt-bg-color;

    li {
      a {
        color: $dt-font-color;
      }
    }
  }

  .mobileMenuBtn {
    span {
      background: $dt-font-color;
    }
  }
}
</style>
